import ServiceCardHome from './ServiceCardHome';

export default ServiceCardHome;
